import React, { useState, useEffect, ReactNode } from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { CurrentSession } from '@/services/repository/session'
import { useModal } from '../modal/Modal'
import './LoggedInLayout.css'
import { isDesktopScreen, useResponsiveChange } from '@/common/device'
import { NavigationRow } from './Navigation'
import { squareLogo } from '@/env/config'

export interface InnerLayoutParams {
  pageName: string
  services: Services
  children: ReactNode
  navbarLeft?: ReactNode
  navbarRight?: ReactNode
  path?: NavigationRow[]
}

export const NavBar = ({ services, navbarLeft, navbarRight }: { services: Services, navbarLeft?: ReactNode, navbarRight?: ReactNode }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { openModal } = useModal()

  useResponsiveChange()

  function redirect(url: string, external: boolean) {
    if (!external) {
      navigate(url)
      return
    }
    window.location.href = url
  }

  interface liProps {
    external?: boolean
    ico?: string
    onClick?: () => void
  }

  function li(title: string, url: string, row: liProps) {
    const { onClick = undefined, ico = undefined, external = false } = row
    return <li onClick={() => onClick ? onClick() : redirect(url, external)} className={location.pathname === url ? 'current' : ''}>
      <div className='wrap'>
        {isDesktopScreen() ? title : null}
        {ico ? <i className={'arrow ' + ico}></i> : <i className='svgfont-arrow-down arrow'></i>}
      </div>
    </li>
  }

  return (
    <nav className='dashboard-navbar'>
      <div className='navbar-body'>
        <div className='left-wrap'>
          {navbarLeft}
        </div>
        <div className='logo-wrap' onClick={() => navigate('/')}>
          <img src={squareLogo} />
        </div>
        <div className='right-wrap'>
          {navbarRight}
        </div>
      </div>
    </nav>
  )
}

export const InnerLayout = (params: InnerLayoutParams) => {
  const { pageName, children } = params
  return <div>
    <NavBar {...params} />
    <section className={`${pageName}-page content-body`}>
      {children}
    </section>
  </div>
}
